import { render, staticRenderFns } from "./Subdomains.vue?vue&type=template&id=1be1f9db"
import script from "./Subdomains.vue?vue&type=script&lang=js"
export * from "./Subdomains.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports